import React, { Component } from 'react';
import { css } from "@emotion/core";
import ClipLoader from "react-spinners/ClipLoader";
import './Spinner.css';

const override = css`
  display: block;
  margin: 0 auto;
  border-color: blak;
`;

class Spinner extends Component {

  render() {
    return (
      <div className="sweet-loading center-screen">
        <ClipLoader
          css={override}
          size={150}
          color={"#00000"}
          loading='Loading'
        />
      </div>
    )
  }
}

export default Spinner;